module.exports = __webpack_public_path__ + "img/bg3.b47ddbb7.png";